import React from "react";
import UsedCarsWorkspace from "../components/UsedCarsWorkspace";

export default function UsedCarsNegotiationPage() {
  return <UsedCarsWorkspace stage="negotiation" />;
}
